import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup, Label,
    Input, Button
} from 'reactstrap';

import { TipoServicoContext } from '../../context/TipoServicoContext';
import { UpdateTipoServicoType } from '../../context/hooks/useTipoServico';
import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    tipoServico: UpdateTipoServicoType | null;
    onUpdated?: () => void;
}

export const EditTipoServicoModal: React.FC<Props> = ({
    isOpen,
    toggle,
    tipoServico,
    onUpdated
}) => {
    const { updateTipoServico } = useContext(TipoServicoContext);

    const [formData, setFormData] = useState<UpdateTipoServicoType | null>(null);

    useEffect(() => {
        if (isOpen) setFormData(tipoServico);
    }, [isOpen, tipoServico]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!formData) return;
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData) return;
        const ok = await updateTipoServico(formData);
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    if (!formData) return null;

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar serviço</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="name">
                            Tipo do serviço
                        </Label>
                        <Input
                            className="form-control-alternative"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label className="form-control-label" htmlFor="value">
                            Valor do serviço
                        </Label>
                        {/* <Input
                            className="form-control-alternative"
                            id="value"
                            name="value"
                            type="number"
                            value={formData.value}
                            onChange={handleChange}
                            required
                        /> */}
                        <CurrencyInput
                            name="value"
                            value={formData.value}
                            onValueChange={v => setFormData(prev => prev ? { ...prev, value: v } : prev)}
                            placeholder="R$ 0,00"
                        />
                    </FormGroup>
                    <div className="d-flex justify-content-end">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Salvar alterações
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditTipoServicoModal;